import React, { useState } from 'react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Star } from 'lucide-react';
import { API_URLS } from '../config/api';

const NewsletterInline = () => {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const subscribe = async () => {
    setMsg('');
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      setMsg('Geçerli bir e-posta girin');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(API_URLS.NEWSLETTER_SUBSCRIBE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (res.ok) {
        setMsg(data.status === 'exists' ? 'Zaten abonesiniz' : 'Abonelik başarılı');
        setEmail('');
      } else {
        setMsg(data.error || 'Bir hata oluştu');
      }
    } catch (e) {
      setMsg('Bağlantı hatası');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
          .insight-input::placeholder {
            color: white !important;
          }
        `}
      </style>
      <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
      <Input
        type="email"
        placeholder="E-posta adresiniz"
        value={email}
        onChange={(e)=>setEmail(e.target.value)}
        className="insight-input flex-1 bg-white/10 border-white/20 text-white placeholder-white"
        style={{ 
          color: 'white'
        }}
        onFocus={(e) => {
          e.target.style.setProperty('color', 'white');
        }}
      />
      <Button onClick={subscribe} disabled={loading} variant="secondary" className="bg-white text-blue-600 hover:bg-gray-100">
        <Star className="w-4 h-4 mr-2" />
        {loading ? 'Gönderiliyor...' : 'Abone Ol'}
      </Button>
      {msg && <p className="text-sm text-blue-100 text-center sm:text-left">{msg}</p>}
      </div>
    </>
  );
};

export default NewsletterInline;






